/* eslint-disable react/jsx-no-bind */
import { Typography } from '@material-ui/core';
import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import CountyContext from '../../contexts/CountyContext';
import FiltersContext from '../../contexts/FiltersContext';
import StoryContext from '../../contexts/StoryContext';
import { displayChildAge, displayFacilityType, displayFamilyType, composeWhereClause } from '../../modules/data';
import { rdsTabulate } from '../../modules/rds';
import { stateFIPS } from '../../modules/states';
import { toFormattedNumber } from '../../modules/text';
import ResponsiveContainer from '../ResponsiveContainer';
import StateCountyMap from '../StateCountyMap';

function CountyMap() {
  const { stateCode } = useParams();
  const {
    primaryColor, lightColor, darkColor, selectionColor, hoverColor,
  } = useContext(StoryContext);
  const {
    county, countyCode, setCounty, setCountyCode,
  } = useContext(CountyContext);
  const [, setReady] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState([]);

  const { settingType, acceptSubsidies } = useContext(FiltersContext);

  useEffect(() => {
    // const server = new RdsServer(process.env.REACT_APP_RDS_SERVER);
    // Instantiate a catalog that exists on the server
    // const catalog = new RdsCatalog(server, 'ccdc');
    // Instantiate a data product that exists on the catalog
    // const dataProduct = new RdsDataProduct(catalog, 'county_licensed_capacity');
    let whereClause = `state_fips=${stateFIPS[stateCode.toUpperCase()]} AND capacity_type=LIC AND is_near_high_risk_site=1`;

    whereClause += composeWhereClause({ settingType });

    if (acceptSubsidies === 'Accept subsidies') {
      whereClause += ' AND is_subsidized=1';
    } else {
      whereClause += ' AND is_subsidized=0';
    }

    rdsTabulate('ccdc', 'county_licensed_capacity', {
      dims: 'county_fips',
      measure: 'value:SUM(capacity)', // TODO: needs to be sum of capacity
      where: whereClause,
      format: 'amcharts',
      inject: false,
    }, true)
      .then((result) => {
        const d = result.parsedBody.dataProvider;
        // const total = d.reduce((a, v) => (a + Number.parseInt(v.capacity, 10)), d[0].capacity);
        // const payload = d.map((v) => Object.assign(v, { value: capacity }));
        setData(d);
      })
      .catch((rdsError) => {
        setError(rdsError);
      })
      .finally(() => {
        setReady(true);
      });
  }, [stateCode, acceptSubsidies, settingType]);

  const toolTipFormatterFunction = function toolTipFormatterFunction(d, dataPoint) {
    if (!dataPoint || !dataPoint.value) {
      return 'No data';
    }
    // console.log(d);
    return `In <b>${d.properties.name} ${d.properties.TYPE}</b>, up to <b>${toFormattedNumber(dataPoint.value)}</b> children attend <b>${displayFacilityType(settingType).toLowerCase().replace('fcc', 'FCC')} programs</b> 
    in high-risk locations and that <b>${acceptSubsidies.toLowerCase()}</b>.`;
  };

  const legendValueFormatter = function legendValueFormatter(v) {
    return Number.parseInt(v, 10);
  };

  const legendLabelFormatter = function legendLabelFormatter(v) {
    return toFormattedNumber(v);
  };

  return (
    <>
      {error && <Typography variant="body1" color="error">{error.message}</Typography>}

      <ResponsiveContainer aspect={1.3} width="100%">
        <StateCountyMap
          data={data}
          stateCode={stateCode}
          legendValueFormatter={legendValueFormatter}
          legendLabelFormatter={legendLabelFormatter}
          legendTitleText={`The darker the color, the greater the number of children who attend ${displayFacilityType(settingType).toLowerCase().replace('fcc', 'FCC')} programs in high-risk locations and that ${acceptSubsidies.toLowerCase()}`}
          colorHigh={darkColor}
          colorLow={lightColor}
          primaryColor={primaryColor}
          selectionColor={selectionColor}
          hoverColor={hoverColor}
          setCounty={setCounty}
          setCountyCode={setCountyCode}
          county={county}
          countyCode={countyCode}
          settingType={settingType}
          displayFacilityType={displayFacilityType}
          displayFamilyType={displayFamilyType}
          displayChildAge={displayChildAge}
          toolTipFormatterFunction={toolTipFormatterFunction}
        />
      </ResponsiveContainer>
    </>
  );
}

export default CountyMap;
